import { Pipe, PipeTransform, inject } from '@angular/core';
import { environment } from '../environments/environment';
import { FeatureFlagsService } from './feature-flags.service';
import { NGXLogger } from 'ngx-logger';

@Pipe({ name: 'imageModifier' })
export class ImageModifierPipe implements PipeTransform {
  private featureFlagsService = inject(FeatureFlagsService);
  private logger = inject(NGXLogger);


  disableImageTransforms = false;

  async translate(sourceUrl: string) {    
    const disableS3Rewrites = await this.featureFlagsService.getBooleanValue('disable-s3-images', false);
    this.logger.log('ImageModifierPipe(translate): disableS3Rewrites', disableS3Rewrites);

    if (disableS3Rewrites) {
      return sourceUrl;
    }

    if (sourceUrl.startsWith('https://senchatea.retool.com/api/file/')) {
      this.logger.log('starts with retool', sourceUrl);
      return sourceUrl.replace('https://senchatea.retool.com/api/file/', 'https://static.sencha-tea.com/rt/');
    } else if (sourceUrl.startsWith('/assets/')) {
      this.logger.log('starts with assets', sourceUrl);
      return `https://static.sencha-tea.com/fe${sourceUrl}`;
    } else {
      this.logger.log('No translation', sourceUrl);
      return sourceUrl;
    }
  }

  async transform(value: string|null|undefined, options?: { width?: number, height?: number, format?: string }): Promise<string|null|undefined> {
    if (!value) return value;

    this.logger.log('ImageModifierPipe(transform): value', value);
    const sourceURL = await this.translate(value);
    this.logger.log('ImageModifierPipe(transform): sourceURL', sourceURL);

    const disableImageTransforms = await this.featureFlagsService.getBooleanValue('disable-image-transforms', false);
    this.logger.log('ImageModifierPipe(transform): disableImageTransforms', disableImageTransforms);


    if (disableImageTransforms || !environment.enableImageTransforms) {
      return sourceURL;
    }

    let transformedURL = '/cdn-cgi/image/';
    const params = [];

    if (options?.width) {
      params.push(`width=${options.width}`);
    }

    if (options?.height) {
      params.push(`height=${options.height}`);
    }

    if (options?.format) {
      params.push(`format=${options.format}`);
    }

    if (params.length > 0) {
      transformedURL += `${params.join(',')}`;
      //Append the sourceurl, but remove any leading slashes from the sourceURL
      transformedURL += `/${sourceURL.replace(/^\/+/, '')}`;
      if (environment.transformPrefix) {
        transformedURL = `${environment.transformPrefix}${transformedURL}`;
      }
    } else {
      transformedURL = sourceURL;
    }

    return transformedURL;
  }

}